/**
 * Formats a file size in bytes into a human-readable string.
 * - Converts to MB if size is 1 MB or greater.
 * - Converts to KB if size is 1 KB or greater.
 * - Defaults to bytes if smaller than 1 KB.
 * @param size - File size in bytes.
 * @returns Formatted file size string (e.g., "1.2 MB", "512.0 KB", "123 B").
 */
export const formatFileSize = (size: number): string => {
  if (size >= 1024 * 1024) {
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  }
  if (size >= 1024) {
    return `${(size / 1024).toFixed(1)} KB`;
  }
  return `${size} B`;
};
